<template>
    <div class="flex flex-col gap-4">
        <export-users-panel :companies="companies"></export-users-panel>
        <export-companies-panel :companies="companies"></export-companies-panel>
        <export-zone-point-counts-panel :companies="companies"></export-zone-point-counts-panel>
        <offboarding-export-panel :companies="companies"></offboarding-export-panel>
        <export-meter-category-preview-panel v-if="isDeveloper" :companies="companies"></export-meter-category-preview-panel>
    </div>
</template>

<script>
import ExportCompaniesPanel from "@/components/Exports/ExportCompaniesPanel.vue";
import ExportMeterCategoryPreviewPanel from "@/components/Exports/ExportMeterCategoryPreviewPanel.vue";
import ExportUsersPanel from "@/components/Exports/ExportUsersPanel.vue";
import ExportZonePointCountsPanel from "@/components/Exports/ExportZonePointCountsPanel.vue";
import OffboardingExportPanel from "@/components/Exports/OffboardingExportPanel.vue";

export default {
    name: "ExportsPage",
    components: {ExportCompaniesPanel, ExportUsersPanel, ExportZonePointCountsPanel, ExportMeterCategoryPreviewPanel, OffboardingExportPanel},
    props: {
        companies: {
            type: Object,
            required: true,
        },
        isDeveloper: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
